import { render, staticRenderFns } from "./FloatPrice.vue?vue&type=template&id=6723b166"
import script from "./FloatPrice.vue?vue&type=script&lang=ts"
export * from "./FloatPrice.vue?vue&type=script&lang=ts"
import style0 from "./FloatPrice.vue?vue&type=style&index=0&id=6723b166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports